import {Routes} from '@angular/router';
import {USER_BOARD} from '../values';

export const ALL_REPORTS_ROUTES: Routes = [
  {
    path: USER_BOARD + '/reports',
    loadChildren: './pages/all-reports-page/all-reports-page.module#AllReportsPageModule'
  }
]



// WEBPACK FOOTER //
// ./src/app/shared/routes/all-reports.routes.ts